import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CourseOfStudyStoreActions,
  CourseOfStudyStoreSelectors,
  CourseOfStudyStoreReducer,
} from './index';
import { CourseOfStudyDto } from '@cradua/data';

@Injectable()
export class CourseOfStudyFacade {
  constructor(
    private store: Store<CourseOfStudyStoreReducer.CourseOfStudyPartialState>
  ) {}

  courseofstudyRecord$ = this.store.select(
    CourseOfStudyStoreSelectors.getSelected
  );
  courseofstudyRecordError$ = this.store.select(
    CourseOfStudyStoreSelectors.getCourseOfStudyError
  );

  getselected() {
    return this.store.select(CourseOfStudyStoreSelectors.getSelected);
  }

  get isLoadingCourseOfStudy() {
    this.store.dispatch(CourseOfStudyStoreActions.loadCourseOfStudy());
    return this.store.select(CourseOfStudyStoreSelectors.loadingCourseOfStudy);
  }

  get loadCourseOfStudy() {
    this.store.dispatch(CourseOfStudyStoreActions.loadCourseOfStudy());
    return this.store.select(CourseOfStudyStoreSelectors.getAllCourseOfStudy);
  }

  addCourseOfStudy(newCourseOfStudy: CourseOfStudyDto[]) {
    this.store.dispatch(
      CourseOfStudyStoreActions.addCourseOfStudy({ newCourseOfStudy })
    );
  }

  updateCourseOfStudy(updateCourseOfStudy: CourseOfStudyDto[]) {
    this.store.dispatch(
      CourseOfStudyStoreActions.updateCourseOfStudy({ updateCourseOfStudy })
    );
  }

  removeCourseOfStudy(ids: string[]) {
    this.store.dispatch(CourseOfStudyStoreActions.removeCourseOfStudy({ ids }));
  }
}
